import React, { useState, useEffect, Fragment } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { association,api,officials } from "../../apis/urls";
import axios from "axios";
import Loader from "../../common-components/loader";
import ReactPaginate from 'react-paginate';
import { $ } from "react-jquery-plugin";
import { Button, ButtonToolbar, Modal, Toggle } from "rsuite";
import { decode } from "html-entities";
import { message, Popconfirm, Switch, Modal as Modals } from "antd";
import { FlexboxGrid } from 'rsuite';
import moment from "moment";

const { confirm } = Modals;

const AssociationList = () => {

    useEffect(() => {
        $('body').removeClass('').addClass('sidebar-collapsed');
        $('html,body').animate({ scrollTop: 0 }, 'fast');
        setLoader(true);
        // $('body').removeClass('sidebar-collapsed sidebar-active').addClass('');
        setTimeout(() => {

            const role = localStorage.getItem('userrole');
            if(role ==="SUPERADMIN"){
                Listing();
            }else{
                message.success('You are not authorized to perform this action.');
                navigate('/')
            }

            });

    }, []);

    const { id } = useParams();
    console.log("id is",id);
    let navigate = useNavigate();

    const [loader,setLoader] = useState(false);
    const [result, setResult] = useState([]);
    const [searchTitle, setSearchTitle] = useState("");
    const [statusTitle, setStatusTitle] = useState("");

    const [sort, setSort] = useState("");
    const [order, setOrder] = useState(true);

    const [currentpage, setCurrentpage] = useState([]);
    const [totalPages, setTotalPages] = useState([]);
    const [totalItems, setTotalItems] = useState([]);
    const [schoolDet, setSchoolDet] = useState('');

    const [open, setOpen] = useState(false);
    const [allLen, setAllLen] = useState('');


    let counts = 0;
    if(result)
    {
        counts = result.length;
    }

    const Listing = (datas) => {

        let SortData = datas?datas:'' 
        let orderData = order?'DESC':'ASC'
        
        let token = "Bearer "+localStorage.getItem('token');
        //console.log(token)
        const instance = axios.create({
            baseURL: association+'?page='+0+'&size='+10+'&sort='+SortData+'&order='+orderData+`&search=`+searchTitle+`&status=`+statusTitle,
            timeout: 1000000,
            headers: {'authorization': token}
          });
    
          instance.get('').then(res => {
            if(res.data.message === "Success"){  
                setResult(res.data.data.dataItems);
                setCurrentpage(res.data.data.currentPage)
                setTotalPages(res.data.data.totalPages)
                setTotalItems(res.data.data.totalItems)
            }else{
                setResult(false)
            }
            console.log("datas", res.data.data.dataItems[0]);    
            setLoader(false)

        });
    }
 



    let token = "Bearer "+localStorage.getItem('token');
    const instances = axios.create({
        baseURL: api,
        timeout: 1000000,
        headers: {'authorization': token}
    });

    const findByTitles = name => {
        let orderData = order?'DESC':'ASC'
        return instances.get(`associations?search=${name}&status=${statusTitle}&sort='${sort}'&order='${orderData}`);
    };


    const findByTitlesss = option => {
        console.log(option)
        let orderData = order?'DESC':'ASC'

        return instances.get(`associations?status=${option}&search=${searchTitle}&sort='${sort}'&order='${orderData}`);
    };



    const onChangeSearchTitles = (e) => {
        const searchTitle = e.target.value;
        setStatusTitle(searchTitle)
        findByTitlesss(searchTitle)
          .then(response => {
            if(response.data.message=== "Success"){
                setResult(response.data.data.dataItems);
                setCurrentpage(response.data.data.currentPage)
                setTotalPages(response.data.data.totalPages)
                setTotalItems(response.data.data.totalItems)
            }else{
                setResult(false)
            }
            console.log(response.data);
          })
          .catch(e => {
            console.log(e);
          });
    };


    const onChangeSearchTitle = e => {
        const searchTitle = e.target.value;
        setSearchTitle(searchTitle);

        findByTitles(searchTitle)
      .then(response => {
        if(response.data.message=== "Success"){
            setResult(response.data.data.dataItems);
            setCurrentpage(response.data.data.currentPage)
            setTotalPages(response.data.data.totalPages)
            setTotalItems(response.data.data.totalItems)
        }else{
            setResult(false)
        }
        console.log("response data",response.data.data);
      })
      .catch(e => {
        console.log(e);
      });


};



    //PAGINATION


     // Invoke when user click to request another page.
     const handlePageClick = (event) => { console.log('EVENTSSS',event)

     $('html,body').animate({ scrollTop: 0 }, 'fast');

     let orderData = order?'DESC':'ASC'
        
     const instance = axios.create({
         baseURL: association+`?search=`+searchTitle+`&status=`+statusTitle+'&page='+event.selected+'&size='+10+'&sort='+sort+'&order='+orderData,
         timeout: 1000000,
         headers: {'authorization': token}
       });

       

     instance.get('').then(res => {

        setResult(res.data.data.dataItems);
        setCurrentpage(res.data.data.currentPage)
        setTotalPages(res.data.data.totalPages)
        setTotalItems(res.data.data.totalItems)

    //  console.log('paginatansresss',res.data.data.items)
     
         setLoader(false);
     }).catch(e => {
     console.log('errorshw',e);
    //  localStorage.removeItem('token')
    //  navigate("/")
     });
 };



 const sortingData = (datas) => {
    setSort(datas)
    setOrder(!order)
    Listing(datas, order)
}


const handleOpen = () => setOpen(true);
const handleClose = () => setOpen(false);

const OfficialListing =(id)=>{
    navigate("/officials/"+id)
}

const ViewDetails =(id)=>{
    navigate("/associationview/"+id)
}

const PendingDetails =(id, name)=>{
    navigate("/official/pending/"+name+"/"+id)
}
    


const exportAssociation  = () => { 

    let token = "Bearer "+localStorage.getItem('token');

    const instance = axios.create({
        baseURL: api+"impex/association/export/officials",
        timeout: 1000000,
        headers: {'authorization': token}
    });
    instance.get('').then((response) =>{
        message.success("Export successfully")
        window.open(api+"impex/download/association/"+response.data.fileName, '_blank')
    }).catch((error) =>{     
        console.log('error',error.message)  
    });
}


const approveButton =(id)=>{

        setResult([]);
        setLoader(true)

        let token = "Bearer "+localStorage.getItem('token');
        //console.log(token)

        const data = {
            ids: id
        }
    
        const instance = axios.create({
            baseURL: association+"status",
            timeout: 1000000,
            headers: {'authorization': token}
          });
    
          instance.patch('', data).then(async res => {


            if(res.data.message === "Status updated successfully!"){

                setTimeout(() => {
                    Listing();
                }, 100);

            }
            // setLoader(false)
        });
}

const [checked, setChecked] = useState(false)

const handleSubmit = (id, status, official) => {

    if(official > 0){
        if (status === "YES") {
            confirm ({ 
            title: "Do you want to reject this association.Press OK to Unapprove",
            okText: 'Reject',
            cancelText: 'Cancel',
            onOk() {
                approveButton(id)
                message.success("Successfully Unapproved")
            }})
        } else {
            confirm ({ 
                title: "Do you want to Approve this Association. Press Ok to Approve",
                okText: 'Approve',
                cancelText: 'Cancel',
                onOk() {
                approveButton(id)
                message.success("Successfully Approved")
            }})
        }
    }else{

        if (status === "NO") {
            confirm ({ 
                title: "Atleast one official is required to approve this Association. Press Ok to Continue",
                okText: 'Continue'
            })
        }else{
            confirm ({ 
                title: "Do you want to reject this association.Press OK to Unapprove",
                okText: 'Reject',
                cancelText: 'Cancel',
                onOk() {
                    approveButton(id)
                    message.success("Successfully Unapproved")
            }}) 
        }
    }

}

const unapprove =()=> {

    let token = "Bearer "+localStorage.getItem('token');

    const instance = axios.create({
        baseURL: `${officials}/payment/unapprove`,
        timeout: 1000000,
        headers: {'authorization': token}
      });

      instance.patch('').then(async res => {

        console.log(res?.data?.message)
        message.success(res?.data?.message)
        setTimeout(() => {
            Listing();
        }, 100);


    });


}

const unApproveConfirmation =()=> {
    confirm ({ 
        title: "Are you sure you want to mark all official payment as pending and Un approve all associations",
        okText: 'Confirm',
        cancelText: 'Cancel',
        onOk() {
            unapprove()
    }})
}


let noo = 1;
    let sl =1;
    return(
        <div>
            <aside className="right-side areas">
                <div className="content-area dash-contentss">
                    <div className="page-title-wrpr">
                        <div className="page-title-left-column">
                            <i className="icon-suitcase1"></i>
                            <h2 className="page-title"> Association List</h2>
                        </div>
                        <div className="page-rightside-action-column">
                        <div className="input-groups mt-3 mb-3 search-grp">
                                <div className="input-group-prepends">
                                <select className="form-controls custom-select" defaultValue={"ALL"} onChange={onChangeSearchTitles}>
                                        <option value="none" disabled hidden>STATUS</option>
                                        <option value="ALL">All</option>
                                        <option value="YES">Approved</option>
                                        <option value="NO">Rejected</option>
                                    </select> 
                                </div>
                                <input type="text" 
                                className="form-controls search-bar"             
                                value={searchTitle}
                                onChange={onChangeSearchTitle}
                                placeholder="Search" />
                                <button className="btn btn-search icon-search"></button>
                                </div>
                            
                                <Link to="/add_associations" data-toggle="tooltip" title="" className="addbtnitem-link text-anchor" data-original-title="Add New School"><i className="icon-add"></i><span>Add New Association</span> </Link>

                        </div>
                    
                    </div>
                
                   

                    <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
                        <li className="breadcrumb-item active" aria-current="page">Associations</li>
                    </ol>
                    </nav>
 
                    {result?
                        <div className="page-title-wrpr" style={{marginTop:'40px'}}>
                            <div className="page-title-left-column">
                                Displaying {(currentpage*10 )+ 1}-{(currentpage*10 )+ counts} of {totalItems} results.
                            </div>
                            <div className="page-rightside-action-column">    
                                <button onClick={unApproveConfirmation} style={{padding:"10px", background:'#4077c7', borderRadius:"5px", color:'#fff', paddingRight:'20px', paddingLeft:'20px'}} className="addbtnitem-link text-anchor">Un approve all officials</button>                      
                                <button onClick={exportAssociation} style={{padding:"10px", background:'#4077c7', borderRadius:"5px", color:'#fff'}} className="addbtnitem-link text-anchor">Export</button>
                            </div>
                        </div>:null
                        }    
 

                        {result?
                        <div className="containers" style={{overflow:'auto'}}>
                           {result?
                            <table className="table table-rules">
                                <thead>
                                    <tr className="rules-table-head">
                                    <th scope="col">Sl.No</th>
                                    <th scope="col" style={{width:"300px"}} onClick={()=>{sortingData("name")}}>Association Name<i style={{fontSize:'20px', position:'relative', top:"4px"}} 
                                        className={sort === "name" && order?"icon-arrow_drop_down":sort === "name" && !order?"icon-arrow_drop_up":"icon-swap_vert"}></i></th>

                                    <th scope="col" style={{minWidth:'180px'}}>Primary Contact</th>
                                    <th scope="col" style={{minWidth:'180px'}}>Secondary Contact</th>
                                    <th scope="col" style={{minWidth:'75px'}} onClick={()=>{sortingData("sports")}}>Sports<i style={{fontSize:'20px', position:'relative', top:"4px"}} 
                                        className={sort === "sports" && order?"icon-arrow_drop_down":sort === "sports" && !order?"icon-arrow_drop_up":"icon-swap_vert"}></i></th>

                                    <th scope="col" style={{minWidth:'135px'}} onClick={()=>{sortingData("status")}}>Status<i style={{fontSize:'20px', position:'relative', top:"4px"}} 
                                        className={sort === "status" && order?"icon-arrow_drop_down":sort === "status" && !order?"icon-arrow_drop_up":"icon-swap_vert"}></i></th>
                                    <th scope="col" style={{textAlign:'center'}}>Actions</th>

                                    </tr>
                                </thead>
                                <tbody className="rules-table-content">
                                        <Fragment>
                                        {result?.map((item,index) =>(

                                            <tr style={{background:item.publish_status === 'PENDING'?'#f0f0f0':'#fff'}}>
                                                <td  style={{verticalAlign:'middle', fontWeight:500}} scope="row">{(index+1)+currentpage*10}</td>
                                                <td  style={{verticalAlign:'middle', fontWeight:500}}>{decode(item.name)}</td>
                                                <td  style={{verticalAlign:'middle', fontWeight:500}}>
                                                    {item.pri_name} {item.pri_lastname}<br />
                                                    {item.pri_email}<br/> 
                                                </td>
                                                <td style={{verticalAlign:'middle', fontWeight:500}}>
                                                    {item.sec_name}<br />
                                                    {item.sec_email}<br/> 
                                                </td>
                                                <td style={{verticalAlign:'middle', fontWeight:500}}>{item.sport}</td>
                                                <td  style={{verticalAlign:'middle', fontWeight:500}}>

                                                    <Switch onClick={()=>{handleSubmit(item.id, item.status, item.official_count)}} checked={item.status === "YES"?true:false} checkedChildren="APPROVED" unCheckedChildren="UNAPPROVED" />

                                                </td>
                                                <td style={{verticalAlign:'middle'}}>

                                                    <div className="list-action-wrpr showicons roundicons-text" >
                                                        <div className="list-action-wrpr">
                                                        <div style={{width:'10px'}} />
                                                        <Link to={"/resetassociationpass/"+item.id+"/"+item.userid}   data-toggle="tooltip" title="Reset Password"><i style={{background:'#77dd77'}}  class="edit icon-lock-open"></i><span>Reset Password</span></Link>
                                                       
                                                        <div style={{width:'10px'}} />
                                                        <button style={{top:"-20px"}}   onClick={()=> {OfficialListing(item.id)}} data-toggle="tooltip" title="Officials">
                                                            <i data-count={item.official_count} className="icon-baseball data-counts-icon" style={{background:'#0A95FF'}}></i>
                                                            <span>Officials</span>
                                                        </button>

                                                        <div style={{width:'10px'}} />
                                                        <button style={{top:"-20px"}}  onClick={()=> {PendingDetails(item.id, item.name)}} data-toggle="tooltip" title="Check Payment Pending">
                                                            <i data-count={item.official_pending} className="icon-baseball data-counts-icon" style={{background:'#AC589F'}}></i>
                                                            <span>Pending</span>
                                                        </button>

                                                        <div style={{width:'10px'}} />

                                                        <button style={{top:"-20px"}}  onClick={()=> {ViewDetails(item.id)}} data-toggle="tooltip" title="View">
                                                            <i className="jobs icon-eye" style={{background:'#FF577F'}}></i>
                                                            <span>&nbsp;View&nbsp;</span>
                                                        </button>


                                                    </div>
                                                    </div>
                                                </td>
                                            
                                            </tr>
                                        ))}
                                        </Fragment>

                                </tbody>   
                                

                            </table>
                            :null
                        } 


                    </div>:
                    
                    <div className="nodata">
                        <h2>Sorry! No Result Found</h2>
                    </div>
                    
                    
                    }


                    {result?
                        <div className="page-title-wrpr" style={{marginTop:'40px'}}>
                            <div className="page-title-left-column">
                                Displaying {(currentpage*10 )+ 1}-{(currentpage*10 )+ counts} of {totalItems} results.
                            </div>
                            <div className="page-rightside-action-column">                          
                                <button onClick={exportAssociation} style={{padding:"10px", background:'#4077c7', borderRadius:"5px", color:'#fff'}} className="addbtnitem-link text-anchor">Export</button>
                            </div>
                        </div>:null
                    }    

                    { 
                        loader?
                        <div>
                            <div className="loader_container"><Loader/></div>
                        </div>
                        :
                        null
                    }

  
       
                    {schoolDet?
                    <Modal role="alertdialog" open={open} onClose={handleClose} size="sm">
                        <Modal.Body style={{fontSize:'18px', textAlign:'center'}}>
                            {schoolDet.length !== 0?'GIAA Member Schools':'Sorry! No Schools Found'}
                        </Modal.Body>
                        <div>
                            {schoolDet.length !== 0?
                            <ul style={{display:'flex', flexDirection:'column', flexWrap:'wrap', height: '30em', overflow:'scroll'}}>
                                {schoolDet?.map((item, index) =>(
                                    <Fragment>
                                    <span style={{fontSize:'14px', width:'60%'}} key={index}>
                                    {noo++}. {item.name}
                                    </span><br />
                                    </Fragment>
                                ))}
                            </ul>:null}
                        </div>
                        <Modal.Footer style={{margin:'auto'}}>
                        <Button onClick={handleClose} appearance="primary">
                            Cancel
                        </Button>
                        </Modal.Footer>
                    </Modal>:null
                    }



                </div>



            </aside>
        </div>

    )
}

export default AssociationList;